import { createFileRoute } from '@tanstack/react-router'

import PenyuluhProvinsiPage from '@/components/pages/backoffice/_klb-penyuluh/_provinsi/containers/PenyuluhProvinsiPage'

export const Route = createFileRoute('/_backoffice/klb-penyuluh/provinsi/')({
  component: PenyuluhProvinsiPage
})
